'use client'
import {
  useTableStyles
} from "./chunk-GEJVU65N.mjs";

// src/tr.tsx
import { chakra, forwardRef } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
var Tr = forwardRef((props, ref) => {
  const styles = useTableStyles();
  return /* @__PURE__ */ jsx(chakra.tr, { ...props, ref, __css: styles.tr });
});

export {
  Tr
};
//# sourceMappingURL=chunk-GIQFRSD6.mjs.map